<template>
  <span
    v-if="iconComponent"
    class="app-icon"
    :style="iconStyle"
    v-bind="$attrs"
    v-on="$listeners">
    <component :is="iconComponent" :size="size" />
  </span>
</template>

<script>
import icons from './icons/registry'

const cache = {}

export default {
  name: 'AppIcon',
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  data () {
    return {
      iconComponent: null
    }
  },
  computed: {
    iconStyle () {
      const size = typeof this.size === 'number' ? `${this.size}px` : this.size
      return {
        color: this.color,
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }
    }
  },
  watch: {
    icon: {
      immediate: true,
      handler () {
        this.loadIcon()
      }
    }
  },
  methods: {
    async loadIcon () {
      this.iconComponent = null
      const loader = icons[this.icon]
      if (!loader) {
        // eslint-disable-next-line no-console
        console.warn(`AppIcon: no existe el icono "${this.icon}" en el registro`)
        return
      }

      if (cache[this.icon]) {
        this.iconComponent = cache[this.icon]
        return
      }

      const module = await loader()
      cache[this.icon] = module.default || module
      this.iconComponent = cache[this.icon]
    }
  }
}
</script>

<style scoped>
.app-icon {
  line-height: 0;
}
</style>
